import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ShieldCheck } from "lucide-react";
import { COMPANY, SERVICES } from "@/lib/constants";

export const Footer = () => {
  return (
    <footer className="border-t border-slate-800/80 bg-[#050B18] pt-16 pb-8" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img src={COMPANY.logo} alt="Atlas Security & Life Safety" className="h-12 w-12 object-contain" />
              <div className="leading-tight">
                <div className="font-display font-extrabold tracking-wider metallic-text">ATLAS</div>
                <div className="text-[9px] tracking-[0.22em] text-[#38BDF8] font-semibold">SECURITY & LIFE SAFETY</div>
              </div>
            </div>
            <p className="text-sm text-slate-400 italic">"{COMPANY.tagline}"</p>
          </div>

          <div>
            <h4 className="font-display text-sm font-semibold text-white uppercase tracking-wider mb-4">Services</h4>
            <ul className="space-y-2.5">
              {SERVICES.map((s) => (
                <li key={s.id}>
                  <a href="#services" className="text-sm text-slate-400 hover:text-[#38BDF8] transition-colors">{s.title}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display text-sm font-semibold text-white uppercase tracking-wider mb-4">Company</h4>
            <ul className="space-y-2.5">
              <li><a href="#why-atlas" className="text-sm text-slate-400 hover:text-[#38BDF8] transition-colors">Why Atlas</a></li>
              <li><a href="#process" className="text-sm text-slate-400 hover:text-[#38BDF8] transition-colors">Our Process</a></li>
              <li><a href="#contact" className="text-sm text-slate-400 hover:text-[#38BDF8] transition-colors">Contact</a></li>
              <li><Link to="/owner" className="text-sm text-slate-400 hover:text-[#38BDF8] transition-colors flex items-center gap-1.5"><ShieldCheck className="h-3.5 w-3.5" /> Owner Portal</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-sm font-semibold text-white uppercase tracking-wider mb-4">Get In Touch</h4>
            <ul className="space-y-3">
              <li>
                <a href={COMPANY.phoneHref} className="flex items-center gap-2.5 text-sm text-slate-400 hover:text-[#38BDF8] transition-colors" data-testid="footer-phone-link">
                  <Phone className="h-4 w-4 text-[#38BDF8]" /> {COMPANY.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${COMPANY.email}`} className="flex items-center gap-2.5 text-sm text-slate-400 hover:text-[#38BDF8] transition-colors break-all" data-testid="footer-email-link">
                  <Mail className="h-4 w-4 text-[#38BDF8] shrink-0" /> {COMPANY.email}
                </a>
              </li>
              <li className="flex items-start gap-2.5 text-sm text-slate-400">
                <MapPin className="h-4 w-4 text-[#38BDF8] shrink-0 mt-0.5" /> {COMPANY.serviceArea}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-slate-800/80 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-500">© {new Date().getFullYear()} {COMPANY.name}. All rights reserved.</p>
          <p className="text-xs text-slate-500">Licensed · Insured · Bonded</p>
        </div>
      </div>
    </footer>
  );
};
